module.exports = __webpack_public_path__ + "media/images/map-40bb9abb52c82305988e5ccc933f0053.svg";